var exports = {
  "banner-border": "x31de4314--626821--banner-border",
  "banner-content-wrapper": "x31de4314--626821--banner-content-wrapper",
  "banner-container": "x31de4314--626821--banner-container",
  "banner": "x31de4314--626821--banner",
  "banner-image": "x31de4314--626821--banner-image",
  "subscription": "x31de4314--626821--subscription",
  "empty": "x31de4314--626821--empty",
};

module.exports = exports;
